import * as React from 'react';

import useDebounce from './useDebounce';

interface Props<Value> {
	delayMilliseconds?: number;
	value: Value;
	children(props: { value: Value; onBlur(): void; onChange(value: Value): void }): React.ReactNode;
	onChange(value: Value): void;
}

export function Debounce<Value>({
	value,
	delayMilliseconds = 800,
	children,
	onChange: originalOnChange,
}: Props<Value>): React.ReactElement | null {
	const [newValue, setNewValue] = React.useState(value);
	const [debounce, cancelDebounce] = useDebounce(delayMilliseconds);

	const onChange = (value: Value) => {
		setNewValue(value);
		debounce(() => {
			originalOnChange(value);
		});
	};

	const onBlur = () => {
		if (cancelDebounce()) {
			originalOnChange(newValue);
		}
	};

	return <>{children({ value: newValue, onBlur, onChange })}</>;
}
